import React, { useState } from 'react';
import axios from 'axios';
import styles from './AddPlot.module.scss'; // Assuming you have a stylesheet for this component
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const AddPlot = () => {
  const [deceasedFirstName, setDeceasedFirstName] = useState('');
  const [deceasedLastName, setDeceasedLastName] = useState('');
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [customerLastName, setCustomerLastName] = useState('');
  const [status, setStatus] = useState('');
  const [block, setBlock] = useState('');
  const [plotRow, setPlotRow] = useState('');
  const [grave, setGrave] = useState('');
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('token');

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('deceasedFirstName', deceasedFirstName);
    formData.append('deceasedLastName', deceasedLastName);
    formData.append('customerFirstName', customerFirstName);
    formData.append('customerLastName', customerLastName);
    formData.append('status', status);
    formData.append('block', block);
    formData.append('plotRow', plotRow);
    formData.append('grave', grave);
    formData.append('image', image);

    try {
        const res = await axios.post(`${process.env.REACT_APP_URL}/plots`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccess('Plot uploaded successfully!');
      setDeceasedFirstName('');
      setDeceasedLastName('');
      setCustomerFirstName('');
      setCustomerLastName('');
      setStatus('');
      setBlock('');
      setPlotRow('');
      setGrave('');
      setImage(null);
    } catch (err) {
      console.error('Failed to upload plot', err);
      setError('Failed to upload plot');
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid className='mt-5 mb-4'>
          <Row className="">
            <Col xs="12" md="8" className='mt-1'>
              <div className={styles.addPlotContainer}>
                <h2 className='text-start mb-3'>Add Plot</h2>
                {error && <p className={styles.error}>{error}</p>}
                {success && <p className={styles.success}>{success}</p>}
                <form onSubmit={handleSubmit} className={styles.addPlotForm}>
                  <input
                    type="text"
                    placeholder="Deceased First Name"
                    value={deceasedFirstName}
                    onChange={(e) => setDeceasedFirstName(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Deceased Last Name"
                    value={deceasedLastName}
                    onChange={(e) => setDeceasedLastName(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Customer First Name"
                    value={customerFirstName}
                    onChange={(e) => setCustomerFirstName(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Customer Last Name"
                    value={customerLastName}
                    onChange={(e) => setCustomerLastName(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Block"
                    value={block}
                    onChange={(e) => setBlock(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Row"
                    value={plotRow}
                    onChange={(e) => setPlotRow(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Grave"
                    value={grave}
                    onChange={(e) => setGrave(e.target.value)}
                    required
                  />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                  
                  />
                  <button type="submit" className='mt-2'>Upload Plot</button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AddPlot;
